export const querySelector = (selector) => {
  try {
    MK.DOM.elements.querySelector[selector] = MK.DOM.elements.querySelector[selector] || document.querySelector(selector)

    if (!MK.DOM.elements.querySelector[selector]) throw Error(`!!! ERROR (DOM.fns.querySelector): Unable to locate element with selector: ${selector}`)

    return MK.DOM.elements.querySelector[selector]
  } catch (error) {
    console.log(error)
    MK.captureException && MK.captureException(error)
    return null
  }
}